<ion-app>
  <!-- Loader Component -->
  <app-loader></app-loader>

  <div class="app-container" [class.sidebar-pinned]="isSidebarPinned()">
    <app-sidebar></app-sidebar>
    <!-- Main Content Area -->
    <div class="main-content">
      <!-- Mobile Header (hidden on guest landing pages) -->
      @if (!layoutChrome.hideHeader()) {
      <ion-header class="mobile-header">
        <ion-toolbar style="--background: var(--color-bg-secondary)">
          <ion-buttons slot="start">
            <ion-button fill="clear" (click)="toggleSidebar()">
              <ion-icon
                name="menu-outline"
                class="text-2xl"
                style="color: var(--color-menu-icon)"
              ></ion-icon>
            </ion-button>
            <div class="header-content">
              <!-- <img
                [src]="horizontalLogoSrc"
                alt="BharatLaw"
                class="header-logo"
              /> -->
              @if (getMaterialIconName(currentHeaderItem.icon)) {
                <span class="material-symbols-outlined header-page-icon">
                  {{ getMaterialIconName(currentHeaderItem.icon) }}
                </span>
              } @else {
                <span class="icon-{{ currentHeaderItem.icon }} header-page-icon"></span>
              }

              <span class="header-page-title">{{
                currentHeaderItem.label
              }}</span>
            </div>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      }

      <!-- Router Outlet for Pages -->
      <ion-content class="page-content">
        <router-outlet></router-outlet>
      </ion-content>
    </div>
  </div>
</ion-app>
